; (function (w) {
	var vh = w.innerHeight * 0.01;

	refreshVH();
	w.addEventListener('load', refreshVH);
	w.addEventListener('resize', refreshVH);
	w.addEventListener('orientationchange', refreshVH);

	function refreshVH() {
		vh = w.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', vh + 'px');
	}
}(window));